import { createRef, Component } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledViewpane = styled.div.withConfig({
  displayName: "MinimapViewpane__StyledViewpane",
  componentId: "sc-106itwg-0"
})(["border:2px dashed gray;position:absolute;background:rgba(196,196,196,0.6);"]);
class MinimapViewpane extends Component {
  constructor(...args) {
    super(...args);
    this.viewpaneRef = /*#__PURE__*/createRef();
    this.state = {
      canvasLeftScroll: null,
      canvasTopScroll: null
    };
    this.centerViewpane = () => {
      const {
        minimapScrollElementRef
      } = this.props;
      const {
        canvasLeftScroll,
        canvasTopScroll
      } = this.state;
      if (this.viewpaneRef.current && minimapScrollElementRef.current && canvasLeftScroll !== null && canvasTopScroll !== null) {
        // Attempting to scroll the viewpane into view while the minimap panel is
        // opening causes the whole page to scroll
        if (minimapScrollElementRef.current.getBoundingClientRect().right < 0) {
          window.requestAnimationFrame(() => {
            this.forceUpdate();
          });
        } else {
          this.viewpaneRef.current.scrollIntoView({
            block: 'center',
            inline: 'center'
          });
        }
      }
    };
    this.attachScrollEventToCanvas = () => {
      const {
        canvasScrollElementRef
      } = this.props;
      if (!canvasScrollElementRef.current) {
        return;
      }
      canvasScrollElementRef.current.addEventListener('scroll', this.scrollEvent);
      this.setState({
        canvasLeftScroll: canvasScrollElementRef.current.scrollLeft,
        canvasTopScroll: canvasScrollElementRef.current.scrollTop
      });
    };
    this.detachScrollEventToCanvas = () => {
      const {
        canvasScrollElementRef
      } = this.props;
      if (!canvasScrollElementRef.current) {
        return;
      }
      canvasScrollElementRef.current.removeEventListener('scroll', this.scrollEvent);
    };
    this.scrollEvent = evt => {
      const target = evt.target;
      const canvasLeftScroll = target.scrollLeft;
      const canvasTopScroll = target.scrollTop;
      let ticking = false;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.setState({
            canvasLeftScroll,
            canvasTopScroll
          });
          ticking = false;
        });
        ticking = true;
      }
    };
  }
  componentDidMount() {
    const {
      canvasScrollElementRef
    } = this.props;
    if (!canvasScrollElementRef.current) {
      return;
    }
    this.attachScrollEventToCanvas();
  }
  componentDidUpdate() {
    this.centerViewpane();
  }
  componentWillUnmount() {
    this.detachScrollEventToCanvas();
  }

  /**
   * By calling this on every lifecycle, we ensure the Viewpane stays
   * in the center of the screen. This prevents the pane from going
   * off screen.
   */

  render() {
    const {
      zoomLevel,
      canvasWidth,
      canvasHeight
    } = this.props;
    const {
      canvasLeftScroll,
      canvasTopScroll
    } = this.state;
    if (canvasLeftScroll === null || canvasTopScroll === null) {
      return null;
    }
    return /*#__PURE__*/_jsx(StyledViewpane, {
      ref: this.viewpaneRef,
      style: {
        height: `${canvasHeight / zoomLevel}px`,
        width: `${canvasWidth / zoomLevel}px`,
        left: `${canvasLeftScroll / zoomLevel}px`,
        top: `${canvasTopScroll / zoomLevel}px`
      }
    });
  }
}
export default MinimapViewpane;